import React from 'react';
import { Row, Col, Alert, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class GearModelsUploadComponent extends React.Component {

  componentDidMount() {
  }

  uploadModelTemplate(templateType) {
    this.props.uploadModelTemplate(this.props.gearModel.get('modelNo'), templateType, this.uploadTemplateFile, {
      activePage: this.props.activePage,
      itemPerPage: this.props.itemPerPage
    });
  }

  render() {

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12}>
            {alertDiv}
          </Col>
        </Row>
        {(this.props.gearModel.get('sizeTypeIsOthers') != 'Y') && (
          <div>
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileA" >
                  <ControlLabel>舊型號PDF模版(洗標左邊) 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('A');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileB" >
                  <ControlLabel>舊型號PDF模版(洗標右邊) 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('B');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileA" >
                  <ControlLabel>新型號PDF模版(洗標左邊) 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('NA');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileA" >
                  <ControlLabel>新型號PDF模版(洗標右邊) 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('NB');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileA" >
                  <ControlLabel>新型號PDF模版(洗標橫式) 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('NC');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {(this.props.gearModel.get('sizeType') == 5 || this.props.gearModel.get('sizeType') == 8) && (
          <div>
            <Row>
              <Col xs={12} sm={12}>
                <FormGroup controlId="uploadTemplateFileA" >
                  <ControlLabel>頭套 PDF 上傳</ControlLabel>
                  <FormControl
                    type="file"
                    onChange={(event) => {
                      this.uploadTemplateFile = event.target.files[0];
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12}>
                <Button style={{ marginRight: 10 }} onClick={(event) => {
                  this.uploadModelTemplate('Hood');
                }} bsStyle="info">
                  上傳
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/GearModelsUploadComponent.jsx